import React, { useEffect } from 'react'
import { useState } from 'react'
import { BackButton } from '@/components/layout/NavBar'
import { Services } from '@/services/services'

import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { Translates } from '@/services/repository/i18n'

import './Contact.css'

export const ContactPage = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const [translates, setTranslates] = useState<Translates>()

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='contact' services={services} translates={translates}
    navbarLeft={<BackButton services={services} translates={translates} />}>

    <div className='lemarpol-contact'>

      <div className="section company-name">Lemarpol Wózki Widłowe Sp. z o.o.</div>
      <div className="section light-text">KRS: 0000038980, NIP: 6760016783, Kapitał zakładowy: 1 191 000,00 zł</div>

      <div className="section">
        e-mail: <a className="email" href="mailto:lemarpol@lemarpol.pl">lemarpol@lemarpol.pl</a><br />
        e-mail: <a className="email" href="mailto:serwis@lemarpol.pl">serwis@lemarpol.pl</a><br />
        e-mail: <a className="email" href="mailto:czesci@lemarpol.pl">czesci@lemarpol.pl</a>
      </div>

      <div className="section">
        <div className="bold">Oddział Zator</div>
        <div className="light-text">32-640 Zator, ul. S. Staszica 21</div>
        <div>
          tel: <a className="phone" href="tel:+48609455872">+48 609 455 872</a><br />
          tel/fax: <a className="phone" href="tel:+48338705113">+48 33 870 51 13</a><br />
          tel/fax: <a className="phone" href="tel:+48338705154">+48 33 870 51 54</a>
        </div>
        <div className="opening-hours">
          Godziny otwarcia: 07:00 - 16:00<br />
          <span className="bold">Załadunek/Rozładunek: 06:30 - 14:30</span>
        </div>
      </div>

      <div className="divider"></div>

      <div className="section">
        <div className="branch">Oddział Koprki / Ożarów Mazowiecki</div>
        <div className="light-text">05-850 Koprki / Ożarów Mazowiecki, ul. Poznańska 478</div>
        <div>
          tel: <a className="email" href="tel:+48663870222">+48 663 870 222</a><br />
          tel/fax: <a className="email" href="tel:+48226641271">+48 22 664-12-71</a><br />
          e-mail: <a className="email" href="mailto:warszawa@lemarpol.pl">warszawa@lemarpol.pl</a>
        </div>
      </div>

      <div className="divider"></div>

      <div className="section">
        <div className="branch">Oddział Poznań</div>
        <div className="light-text">62-070 Zakrzewo, ul. Poznańska 1</div>
        <div>
          tel: <a className="email" href="tel:+48506860742">+48 506 860 742</a>
        </div>
      </div>

    </div>

  </MainPageLayout>
}
